import regexParser from 'regex-parser';
import logError from '@/utils/log-error';
import keyCodes from '@/utils/key-codes';

const SELECTOR = 'vjs-orcid-filter';

const DEFAULT_DELIMITER = '-';

const VALID_KEYS = [
    keyCodes.BACKSPACE,
    keyCodes.TAB,
    keyCodes.ENTER,
    keyCodes.HOME,
    keyCodes.END,
    keyCodes.LEFT,
    keyCodes.RIGHT,
    keyCodes.UP,
    keyCodes.DOWN,
    keyCodes.DELETE,
    keyCodes.INSERT
];

class OrcidFilter {
    constructor(el) {
        if(el.nodeName !== 'INPUT' || el.getAttribute('type') !== 'text') {
            logError('The Orcid Filter component only works on a <input type="text" /> element.');
            return;
        }

        this.input = el;
        this.prefix = this.input.dataset.prefix;
        this.maxCharacters = Number(this.input.dataset.maxCharacters) || null;
        this.regex = this.input.dataset.regex ? regexParser(this.input.dataset.regex) : new RegExp(/^\d{0,15}(?:\d|X)$/);
        this.delimiter = this.input.dataset.delimiter || DEFAULT_DELIMITER;

        this.init();
    }

    init() {
        this.setupListeners();
    }

    destroy() {
        this.destroyListeners();
    }

    setupListeners() {
        this.input.addEventListener('keydown', this.bindedKeydown);
        this.input.addEventListener('input', this.bindedInput);
        this.input.addEventListener('blur', this.bindedBlur);
    }

    destroyListeners() {
        this.input.removeEventListener('keydown', this.bindedKeydown);
        this.input.removeEventListener('input', this.bindedInput);
        this.input.removeEventListener('blur', this.bindedBlur);
    }

    onBlur() {
        if(!this.input.value) {
            this.input.value = this.prefix;
        }
    }

    onInput() {
        this.input.value = this.input.value.replace(/[^0-9]/g, '');
        this.setValue();
    }

    onKeydown(evt) {
        const key = evt.which || evt.keyCode;

        if((evt.ctrlKey && key === 65) || (evt.ctrlKey && key === 86) || VALID_KEYS.includes(key)) {
            return;
        }

        evt.preventDefault();
        this.setValue(evt.key);
    }

    setValue(key = '') {
        const delimiterRegex = new RegExp(this.delimiter, 'g');
        let value = this.input.value.replace(this.prefix, '').replace(delimiterRegex, '');
        value = value + key;

        if(this.maxCharacters && value.length > this.maxCharacters) {
            value = value.substring(0, this.maxCharacters);
        }

        if(this.regex.test(value)) {
            value = value.match(/.{1,4}/g).join(this.delimiter);
            this.input.value = this.prefix + value;
        }
    }

    bindedBlur = this.onBlur.bind(this);
    bindedInput = this.onInput.bind(this);
    bindedKeydown = this.onKeydown.bind(this);
}

let instanceArr = [];

export function destroy() {
    instanceArr.forEach(instance => instance?.destroy());
    instanceArr.splice(0, instanceArr.length);
}

export default function() {
    const elements = document.querySelectorAll(`[${SELECTOR}]`);
    elements?.forEach((element, i) => {
        instanceArr[i] = new OrcidFilter(element);
    });
}
